import { TransportMode } from '../../../../models/transport-mode.enum';
import { TransportSubMode } from '../../../../models/transport-sub-mode.enum';
import { IMunicipality } from '../../../../models/municipality.model';
import { IVersionedLine } from '../../../../models/versioned-line.model';
import { ILine } from '../../../../models/line.model';
import { DateTime } from 'luxon';

export class MultiFacetAutocompleteApiModel {
  municipalities!: MultiFacetMunicipalityApiModel[];
  lines!: MultiFacetVersionedLineApiModel[];
}

export class MultiFacetMunicipalityApiModel {
  public static mapToBusinessModel(apiModel: MultiFacetMunicipalityApiModel): IMunicipality {
    return {
      gid: apiModel.gid,
      name: apiModel.name,
      shortName: apiModel.shortName,
    };
  }

  public gid!: string;
  public name!: string;
  public shortName!: string;
}

export class MultiFacetVersionedLineApiModel {
  public gid!: string;
  public technicalLineNumber!: string;
  public versions!: MultiFacetLineApiModel[];

  public static mapToBusinessModel(apiModel: MultiFacetVersionedLineApiModel): IVersionedLine {
    return {
      gid: apiModel.gid,
      technicalLineNumber: apiModel.technicalLineNumber,
      versions: apiModel.versions.map((v) => MultiFacetLineApiModel.mapToBusinessModel(v)),
    };
  }
}

export class MultiFacetLineApiModel {
  public gid: string | undefined;
  public technicalLineNumber!: string;
  public name!: string;
  public shortName!: string;
  public backgroundColor: string | undefined;
  public foregroundColor: string | undefined;
  public borderColor: string | undefined;
  public directionName: string | undefined;
  public transportMode!: TransportMode;
  public transportSubMode!: TransportSubMode;
  public contractorId!: number;
  public isPublicTransport: boolean | undefined;
  public isWheelchairAccessible: boolean | undefined;
  public municipalities!: MultiFacetMunicipalityApiModel[];
  public appliesFrom!: string;
  public appliesUpto: string | undefined;
  public designation: string | undefined;
  public transportAuthorityGid: string | undefined;

  public static mapToBusinessModel(apiModel: MultiFacetLineApiModel): ILine {
    return {
      gid: apiModel.gid,
      technicalLineNumber: apiModel.technicalLineNumber,
      name: apiModel.name,
      shortName: apiModel.shortName,
      backgroundColor: apiModel.backgroundColor,
      foregroundColor: apiModel.foregroundColor,
      borderColor: apiModel.borderColor,
      directionName: apiModel.directionName,
      transportMode: apiModel.transportMode,
      transportSubMode: apiModel.transportSubMode,
      contractorId: apiModel.contractorId,
      isPublicTransport: apiModel.isPublicTransport,
      isWheelchairAccessible: apiModel.isWheelchairAccessible,
      municipalities: apiModel.municipalities?.map((m) => MultiFacetMunicipalityApiModel.mapToBusinessModel(m)),
      appliesFrom: DateTime.fromISO(apiModel.appliesFrom),
      appliesUpto: apiModel.appliesUpto ? DateTime.fromISO(apiModel.appliesUpto) : undefined,
      designation: apiModel.designation,
      transportAuthorityGid: apiModel.transportAuthorityGid,
    };
  }
}
